module.exports = __webpack_public_path__ + "img/partnership.c168bc75.webp";